import React from "react";
import {isMobile, isDesktop} from 'react-device-detect';
import Navigation from "../../components/static/Navigation";
import Footer from "../../components/static/Footer";
import VBLeaflet from "@vb-js-commons/new/vbLeaflet";
import VBMultiOption from "@vb-js-commons/new/vbMultiOption";
import Cookies from 'js-cookie';
import VBDropdown from "@vb-js-commons/new/vbDropdown";
import VBLoadingScreen from '@vb-js-commons/vbLoadingScreen';
import VBSearchInput from '@vb-js-commons/new/vbSearchInput';

class Auctions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ads: Window.react_data.ads,
            sold_ads: Window.react_data.sold_ads,
            regions: Window.react_data.regions,
            wood_types: Window.react_data.wood_types,
            trees: Window.react_data.trees,
            ad_types: Window.react_data.ad_types,
            url_quoted_company_names: Window.react_data.url_quoted_company_names,
            sort: Window.react_data.sort,
            form: Window.react_data.form,
            no_results: Window.react_data.no_results,
            checked: false, //this is either true or false
            showLoading: false,
        }

        this.navigation = React.createRef();
        this.map = React.createRef();

    }
    setUpMap(allAds) {
        setTimeout(() => {
            const map = this.map.current.state.map;
            map.eachLayer((layer) => {
                if (layer instanceof L.Marker) {
                    map.removeLayer(layer);
                }
            });
            if (map && allAds.length > 0) {

                const bounds = L.latLngBounds();

                allAds.forEach((ad) => {
                    const { latitude, longitude, id } = ad;

                    if (latitude !== null && longitude !== null) {
                        const isAd = this.state.ads.includes(ad)
                        if (isAd) {
                            const path = "img/map-markers/marker_pin_secondary-orange.svg";
                            const icon = L.icon({
                                iconUrl: Window.static_path + path,
                                iconSize: [32, 32],
                                shadowSize: [32, 32],
                                iconAnchor: [16, 32],
                                shadowAnchor: [16, 32],
                                popupAnchor: [0, -16]
                            });

                            let marker = L.marker([latitude, longitude], { icon: icon }).setZIndexOffset(1000).addTo(map)

                            marker.on("click", function () {

                                window.location.href = `/auctions/${id}`

                            });

                        }
                        else {
                            const path = "img/map-markers/marker_pin_primary-main.svg"
                            const icon = L.icon({
                                iconUrl: Window.static_path + path,
                                iconSize: [32, 32],
                                shadowSize: [32, 32],
                                iconAnchor: [16, 32],
                                shadowAnchor: [16, 32],
                                popupAnchor: [0, -16]
                            });

                            let marker = L.marker([latitude, longitude], { icon: icon }).addTo(map);

                        }

                        bounds.extend([latitude, longitude]);
                    }
                });

                if(Window.react_data.trustedBuyer){
                    map.fitBounds(bounds, { padding: [50, 50] });
                }
            }
        }, 1000);
    }
    componentDidMount() {
        this.setUpMap(this.state.ads)
      
        if (!Window.react_data.trustedBuyer) {
            setTimeout(()=>{
                this.map.current.state.map.setMaxZoom(5)
            },10)

        }

    }


    handleFilter() {
        this.setState({ showLoading: true });
        const { selectedRegions, selectedWood_types, selectedTrees, selectedAd_types, adId_search, selectedUrl_quoted_company_names, selectedSort,
        } = this.state;

        const filterOptions = {
            regions: selectedRegions, wood_types: selectedWood_types, trees: selectedTrees, ad_types: selectedAd_types, ad_id: adId_search, url_quoted_company_names: selectedUrl_quoted_company_names, sort: selectedSort,
        };

        const headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': Cookies.get('csrftoken'),
        };

        fetch(`/kop-virke/virkesauktioner/`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: headers,
            body: JSON.stringify(filterOptions),
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ ads: data.ads, sold_ads: data.sold_ads , showLoading:false}, () => {
                    if (this.state.checked == true) {
                        const allAds = [...this.state.sold_ads, ...this.state.ads]
                        this.setUpMap(allAds)

                    }
                    else if (this.state.checked == false) {
                        this.setUpMap(this.state.ads)
                    }
                }
                )
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }

    handleCardClick = (id) => {
        window.open(`/auctions/${id}`, '_blank');
    };

    formatArrangementLabel(arrangements) {
        if (arrangements == "Vindfallen") {
            return "Övrig avverkning";
        }
        return arrangements;
    }

    formatContractTypeLabel(ad) {
        if (ad.ad_type_label) {
            return ad.ad_type_label;
        }
        if (ad.ad_type) {
            return ad.ad_type[0].toUpperCase() + ad.ad_type.slice(1);
        }
        return "";
    }

    formatTimberVolumeM3fub(value) {
        if (value || value === 0) {
            return value + " m³fub";
        }
        return "0 m³fub";
    }

    formatGrotVolumeM3(value) {
        if (value || value === 0) {
            return value + " m³";
        }
        return "–";
    }

    renderAdCardDetails(ad) {
        const arrangementLabel = this.formatArrangementLabel(ad.arrangements);
        const contractLabel = this.formatContractTypeLabel(ad);

        if (ad.is_grot || ad.ad_type === 'grot' || ad.arrangement_key === 'grot') {
            const volume = ad.grot_volume ?? ad.total_volume;
            return (
                <div className="mb-3 flex w-full flex-wrap justify-between">
                    <p className="pr-4 w-1/2 md:w-1/3 text-sm"><span className="neutral-pebble">Kontraktstyp</span><br />{contractLabel}</p>
                    <p className="pr-4 w-1/2 md:w-1/3 text-sm"><span className="neutral-pebble">Typ</span><br />{arrangementLabel}</p>
                    <p className="pr-4 w-1/2 md:w-1/3 text-sm"><span className="neutral-pebble">Volym biobränsle</span><br />{this.formatGrotVolumeM3(volume)}</p>
                    <p className="pr-4 mb-0 w-1/2 md:w-1/3 text-sm"><span className="neutral-pebble">Biobränslet täckt</span><br />{ad.grot_heap_covered_label || "–"}</p>
                    <p className="mb-0 pr-4 w-1/2 md:w-1/3 text-sm"><span className="neutral-pebble">Biobränslet uppsamlat</span><br />{ad.grot_collected_label || "–"}</p>
                </div>
            );
        }

        return (
            <div className="mb-3 flex w-full flex-wrap justify-between">
                <p className="pr-4 w-1/2 md:w-1/3 text-sm"><span className="neutral-pebble">Kontraktstyp</span><br />{contractLabel}</p>
                <p className="pr-4 w-1/2 md:w-1/3 text-sm"><span className="neutral-pebble">Typ</span><br />{arrangementLabel}</p>
                <p className="pr-4 w-1/2 md:w-1/3 text-sm"><span className="neutral-pebble">Total Volym</span><br />{this.formatTimberVolumeM3fub(ad.total_volume)}</p>
                <p className="pr-4 mb-0 w-1/2 md:w-1/3 text-sm"><span className="neutral-pebble">Gran</span><br />{this.formatTimberVolumeM3fub(ad.gran)}</p>
                <p className="mb-0 pr-4 w-1/2 md:w-1/3 text-sm"><span className="neutral-pebble">Tall</span><br />{this.formatTimberVolumeM3fub(ad.tall)}</p>
                <p className="pr-4 mb-0 w-1/2 md:w-1/3 text-sm"><span className="neutral-pebble">Löv</span><br />{this.formatTimberVolumeM3fub(ad.lov)}</p>
            </div>
        );
    }

    handleBookmarkClick(adId, event) {
        event.stopPropagation(); //stop event
        this.setState({ showLoading: true });

        const bookedAd = { bookmarked: adId }
        const headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': Cookies.get('csrftoken'),
        };

        fetch(`/kop-virke/virkesauktioner/`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: headers,
            body: JSON.stringify(bookedAd),
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ ads: data.ads, sold_ads: data.sold_ads }, () => {
                    //const allAds = [...this.state.sold_ads, ...this.state.ads]
                    const allAds = this.state.ads
                    this.setUpMap(allAds);
                    this.setState({ showLoading: false });
                })
            })
            .catch(error => {
                console.error('Error:', error);
                this.setState({ showLoading: false });
            });

    };

    render() {
        const today = new Date().toISOString().slice(0, 10);
        const isSummerPopupVisible = today > "2023-12-22" && today < "2023-01-08";


        return <div className="w-full p-0">
            <Navigation />
            {Window.user_data.isBanned ? (
                <section className='bg-white pt-0 md:pt-3'>
                    <div className="container">
                        <div className="flex flex-wrap md:flex-row items-start justify-center">
                            <div className='md:w-1/2 w-full'>
                                <img src={`${Window.static_path}img/icons/Warning.svg`} className='tertiary-red-filter mr-1' height='16px' width='16px' alt='Warning Icon' />
                                <p className='text-center mb-0 tertiary-red subtitle font-bold mb-4'>
                                    Du har inte tillgång till att öppna och se annonser, kontakta Treebula för mer information på{' '}
                                    <a className='underline font-bold' style={{ cursor: 'pointer' }} href="tel:00468339944">08339944</a> eller maila till <a className='underline font-bold' style={{ cursor: 'pointer' }} href="mailto:info@virkesborsen.se">info@virkesborsen.se.</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            ) : (
                <div className="w-full fs-6 p-0">
                    <VBLoadingScreen
                        show_loading={this.state.showLoading}
                        disable_reload_timeout={true}
                        loading_text={null} />
                    <div className="bg-white">
                        <section className="bg-white pt-0 md:pt-3">
                            <div className="container neutral-charcoal">
                                <div className="flex flex-wrap justify-between">
                                    {/* Left side */}
                                    <div className="lg:w-[calc(50%-8px)] w-full">
                                        <div className="p-6 rounded-top bg-neutral-cloud">
                                            <h2 className="fs-4">
                                                Virkesannonser
                                            </h2>
                                            <div className="flex justify-between">
                                                {/* Filter your result */}
                                                <p className="fs-6 mr-auto mb-0">Filtrera ditt resultat: {this.state.ads.length} </p>
                                                
                                            </div>
                                            <div className="mt-4 flex jutify-content-between flex flex-wrap">
                                                <div className="w-full md:w-1/3 pr-2">
                                                    {/* Län aka County */}
                                                    <VBMultiOption
                                                        inputStyle={{ minHeight: 0 }}
                                                        label="Län"
                                                        placeholder="Vänligen välj"
                                                        options={this.state.regions}
                                                        onChange={(val) => {
                                                            this.setState({ selectedRegions: val }, () => {
                                                                this.handleFilter()
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="w-full md:w-1/3 pr-2">
                                                    {/* Sortiment aka Range */}
                                                    <VBMultiOption
                                                        inputStyle={{ minHeight: 0 }}
                                                        label="Sortiment"
                                                        placeholder="Vänligen välj"
                                                        options={this.state.wood_types}
                                                        onChange={(val) => {
                                                            this.setState({ selectedWood_types: val }, () => {
                                                                this.handleFilter()
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                {/* Trädslag aka Tree species */}
                                                <div className="w-full md:w-1/3 pr-2">
                                                    <VBMultiOption
                                                        inputStyle={{ minHeight: 0 }}
                                                        label="Trädslag"
                                                        placeholder="Vänligen välj"
                                                        options={this.state.trees}
                                                        onChange={(val) => {
                                                            this.setState({ selectedTrees: val }, () => {
                                                                this.handleFilter()
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="mt-4 flex jutify-content-between flex flex-wrap">
                                                <div className="w-full md:w-1/3 pr-2">
                                                    {/* Kontraktstyp aka Contract type */}
                                                    <VBMultiOption
                                                        inputStyle={{ minHeight: 0 }}
                                                        label="Kontraktstyp"
                                                        placeholder="Vänligen välj"
                                                        options={this.state.ad_types}
                                                        onChange={(val) => {
                                                            this.setState({ selectedAd_types: val }, () => {
                                                                this.handleFilter()
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                {Window.react_data.trustedBuyer && <div className="w-full md:w-1/3 pr-2">
                                                    {/* Annonsid */}
                                                
                                                    <VBSearchInput
                                                        inputStyle={{minHeight: 0}} 
                                                        label="AnnonsID/Fastighet"
                                                        initial={""}
                                                        placeholder="Sök"
                                                        onChange={(val) => { val.length === 0 || val.length > 2 ? this.setState({adId_search:val},()=>{this.handleFilter()}): null}}
                                                        />
                                                </div>}
                                                {/* Sortera efter aka Sort by */}
                                                <div className="w-full md:w-1/3 pr-2">
                                                    <VBDropdown
                                                        inputStyle={{ minHeight: 0 }}
                                                        label="Sortera"
                                                        placeholder="Vänligen välj"
                                                        initial={""}
                                                        options={this.state.sort}
                                                        onChange={(val) => {
                                                            this.setState({ selectedSort: [val] }, () => {
                                                                this.handleFilter()
                                                            })
                                                        }} />
                                                </div>
                                            </div>
                                            <div className='flex mt-6 justify-start'>
                                                    {/* Hide or show old ads */}
                                                    {/* <VBToggle
                                                        label={<p className="fs-7 mb-0">Dölj/Visa gamla annonser</p>}
                                                        checked={this.state.checked}
                                                        onChange={(val) => {
                                                            this.setState({ checked: val })
                                                            if (val == true) {
                                                                const allAds = [...this.state.sold_ads, ...this.state.ads]
                                                                this.setUpMap(allAds)
                                                            }
                                                            else if (val == false) {
                                                                this.setUpMap(this.state.ads)
                                                            }
                                                        }} /> */}

                                                    {/*<VBCheckbox
                                                        label={<p className="fs-7 mb-0">Dölj/Visa gamla annonser</p>}
                                                        initial={this.state.checked}
                                                        onClick={(val) => {
                                                            this.setState({ checked: val })
                                                            if (val == true) {
                                                                //const allAds = [...this.state.sold_ads, ...this.state.ads]
                                                                const allAds = this.state.ads
                                                                this.setUpMap(allAds)
                                                            }
                                                            else if (val == false) {
                                                                this.setUpMap(this.state.ads)
                                                            }
                                                        }}
                                                    /> */}

                                                </div>
                                        </div>

                                        {/* when there's no results */}
                                        <div className="flex flex-col lg:flex-row rounded-b justify-between items-center p-4 bg-neutral-cloud-600">

                                            {this.state.no_results && this.state.ads ? (

                                                <span className="mb-2 md:mb-0">Inga resultat. Här är några auktioner som kanske intresserar dig:</span>

                                            ) : this.state.ads ? (

                                                <span>{this.state.ads.length} pågående {this.state.ads.length > 1 ? "auktioner" : "auktion"}. Klicka på annons nedan:</span>

                                            ) : (

                                                <span>Inga resultat. Här ser du äldre avslutade annonser:</span>

                                            )}
                                            <a href="/salja-virke/c/" className="flex justify-center w-full lg:w-auto n-btn btn-core btn-sm border-0 whitespace-nowrap"><img src={Window.static_path +"img/icons/icon-left-dark.svg"} className="mr-2"/>Skapa annons</a>
                                        </div>

                                        <div className="card-container" style={{ maxHeight: "400px", overflowY: "scroll", scrollbarWidth: "auto", msOverflowStyle: "auto" }}>
                                            {/* ads and sold_ads */}

                                            {this.state.ads.map((ad) => {
                                                return (
                                                    <div key={ad.id} className="hover-bg-primary-core-200 border border-stone-300" style={{ cursor: "pointer", borderRadius: "0" }} onClick={() => this.handleCardClick(ad.id)}>
                                                        <div className="p-6">
                                                            <div className="flex flex-wrap justify-between">
                                                                <div className="flex bg-supp-forest-green-400 rounded-sm gap-2 mb-4 pl-2 items-center justify-center pr-2 md:me-0 white py-2">
                                                                    <img
                                                                        src={`${Window.static_path}img/icons/${ad.bookmarked ? 'bookmark_star_orange.svg' : 'bookmark_star.svg'}`}
                                                                        height='16px'
                                                                        width='16px'
                                                                        alt='BookMark'
                                                                        onClick={(e) => { this.handleBookmarkClick(ad.id, e) }}
                                                                    />

                                                                    <p className="px-1 mb-0 font-medium fs-6">
                                                                        #{ad.id} {ad.region}</p>
                                                                </div>
                                                                {ad.auction_is_over ? (
                                                                    <p className="fs-7"><span className="neutral-pebble">Slutdatum</span><br />
                                                                        {ad.end_time}</p>
                                                                ) : ad.auction_in_future ? (

                                                                    <p className="fs-7"><span className="neutral-pebble">Startdatum</span><br />
                                                                        {ad.start_time}</p>

                                                                ) : ad.auction_is_live ? (

                                                                    <p className="fs-7"><span className="neutral-pebble">Slutdatum</span><br />
                                                                        {ad.end_time}</p>

                                                                ) : null}
                                                            </div>
                                                            <div className="flex flex-wrap fs-7">
                                                                {this.renderAdCardDetails(ad)}
                                                            </div>
                                                        </div>

                                                    </div>
                                                )

                                            })}

                                            {this.state.checked == true && this.state.sold_ads.map((ad) => {
                                                return (
                                                    <div key={ad.id} className="hover-bg-primary-core-200" style={{ cursor: "pointer",borderRadius: "0" }} onClick={() => this.handleCardClick(ad.id)}>
                                                        <div className="p-6">
                                                            <div className="flex justify-between">
                                                                <div className="flex bg-supp-forest-green-400 rounded mb-4 pl-2 items-center pb-4 md:pb-0 mr-4 md:me-0 white">
                                                                    <img
                                                                        src={`${Window.static_path}img/icons/${ad.bookmarked ? 'bookmark_star_orange.svg' : 'bookmark_star.svg'}`}
                                                                        height='16px'
                                                                        width='16px'
                                                                        alt='BookMark'
                                                                        onClick={(e) => { this.handleBookmarkClick(ad.id, e) }} />

                                                                    <p className="mb-0 rounded px-1 py-2 font-medium fs-6 md:p-2" style={{ height: "40px" }}>#{ad.id} {ad.region}</p>
                                                                </div>
                                                                {ad.auction_is_over ? (
                                                                    <p className="fs-7"><span className="neutral-pebble">Slutdatum</span><br />
                                                                        {ad.end_time}</p>
                                                                ) : ad.auction_in_future ? (

                                                                    <p className="fs-7"><span className="neutral-pebble">Startdatum</span><br />
                                                                        {ad.start_time}</p>

                                                                ) : ad.auction_is_live ? (

                                                                    <p className="fs-7"><span className="neutral-pebble">Slutdatum</span><br />
                                                                        {ad.end_time}</p>

                                                                ) : null}
                                                            </div>
                                                            <div className="flex flex-wrap fs-7">
                                                                {this.renderAdCardDetails(ad)}
                                                            </div>
                                                        </div>

                                                    </div>
                                                )
                                            })}

                                        </div>

                                    </div>
                                    {/* Right side */}
                                    <div className="lg:w-[calc(50%-8px)] hidden lg:block p-0" style={{ height: "800px" }}>
                                        <VBLeaflet ref={this.map} id="auctions" baseMap="Mapbox Satelite" />
                                    </div>
                                </div>
                            </div>

                        </section>

                    </div>
                    {/* ends here no footer */}
                </div>
            )}
            {isSummerPopupVisible && (
                <div>
                    <h2>Ser det tomt ut?</h2>
                    <p>Från och med <span>22 December och fram till 8 Januari</span> visar vi inte mycket annonser här.
                        <span>Kom tillbaka i Januari</span> så hittar du mycket mer virke till salu</p>
                    <button
                        onClick={{}}
                        className="btn blue"
                    >Stäng</button>
                </div>
            )}
            <Footer />
        </div>
    }
}

export default Auctions;


// Custom scrollbar CSS
const customScrollbarCSS = `
.card-container {
    max-height: 480px;
    overflow-y: auto;
}

.card-container::-webkit-scrollbar {
    width: 8px;
}

.card-container::-webkit-scrollbar-thumb {
    background-color: #818887;
    border-radius: 4px;
}

.card-container::-webkit-scrollbar-track {
    background-color: #f1f1f1;
}
`;
const styleTag = document.createElement('style');
styleTag.type = 'text/css';
styleTag.appendChild(document.createTextNode(customScrollbarCSS));
document.head.appendChild(styleTag);